import {
    LOGIN,
    LOGOUT,
    SET_AUTH_TOKEN,
    REMOVE_AUTH_TOKEN,
    SET_LOGGED_USER,
    SET_USER_ROLE,
    REMOVE_USER_ROLE
} from "./action_types"

export const loginUser = () => {
    return {
        type: LOGIN
    };
};
export const logoutUser = () => {
    return {
        type: LOGOUT
    };
};
export const setAuthToken = (authToken) => {
    return {
        type: SET_AUTH_TOKEN,
        authToken
    };
};
export const removeAuthToken = () => {
    return {
        type: REMOVE_AUTH_TOKEN
    };
};
export const setLoggedUser = (user) => {
    return {
        type: SET_LOGGED_USER,
        user
    };
};

export const setUserRole = (role) => {
    return {
        type: SET_USER_ROLE,
        role
    };
};
export const removeUserRole = () => {
    return {
        type: REMOVE_USER_ROLE
    };
};